import { PATHS } from '@/fractals/constants'
import axios from 'axios'
import { getCookies } from 'cookies-next'
import { v4 as uuidv4 } from 'uuid'

type TypeLeadProps = {
  // id: string
  event?: 'lead' | 'getmail'
  program: {
    id: string
    title: string
    price: number
    category: string
    studyField: string
  } | null
  googleClientId: string | null
  email?: string | null
}

type Lead = {
  name?: string
  phoneNumber: string
  email?: string
  promocode?: string
  pdfData?: {
    name: string
    url: string
  }[]
  price?: number | null
}

const margetingLead = ({ program, googleClientId }: TypeLeadProps) => {
  window?.dataLayer?.push({
    event: 'lead',
    ecommerce: {
      add: {
        actionField: {
          // id,
          googleClientId
        },
        products: [
          {
            id: program?.id,
            name: program?.title,
            price: program?.price,
            category: program?.category,
            studyField: program?.studyField
          }
        ]
      }
    }
  })
}

// const sendLeadToSravni = async (lead: Lead) => {
//   const cookies = getCookies()
//   const leadFromSravni = checkIsLeadFromSravni(cookies)

//   if (!leadFromSravni) return

//   const TRANSACTION_ID = cookies.utm_content
//   const OFFER_ID = 1848
//   const AMOUNT = cost

//   const res = await axios.get(
//     `https://sravni.go2cloud.org/aff_lsr?Offer_id=${OFFER_ID}&amount=${AMOUNT}&transaction_id=${TRANSACTION_ID}`
//     // `http://localhost:3000/aff_lsr?offer_id=${OFFER_ID}&amount=${AMOUNT}&transaction_id=${TRANSACTION_ID}`
//   )

//   return res.data
// }

// const sendLeadMagnet = async(lead: Lead) =>
//   axios.post(`${PATHS.front.api.leadmagnet.index}`, {
//     ...lead
//   })

export const sendLead = async (lead: Lead) => {
  const req = await axios.post(`${PATHS.front.api.lead.index}`, {
    ...lead
  })

  //   if (isJournalPage) {
  //     const reqMagnet = await axios.post(`${PATHS.front.api.leadmagnet.index}`, {
  //       ...lead
  //     })
  //   }

  if (req.status === 200) {
    const cookies = getCookies()

    // if (isJournalPage) sendLeadMagnet(lead);
    // if (leadFromSravni && isProgramPage) sendLeadToSravni(lead)

    // if (isProgramPage && YandexEcommerceProduct) {
    //   sendPurchaseEvent([YandexEcommerceProduct])
    // }

    const lastUtmSource = cookies.utm_source
    const lastUtmCampaign = cookies.utm_campaign
    const lastClkUid = cookies.cl_uid
    const leadHook = {
      ...lead,
      utms: {
        utm_source: lastUtmSource,
        utm_campaign: lastUtmCampaign,
        cl_uid: lastClkUid
      }
    }

    await axios.post(`${PATHS.front.api.webhook.index}`, leadHook)

    sessionStorage.removeItem('referer')
    sessionStorage.removeItem('user_uuid')
    sessionStorage.setItem('user_uuid', JSON.stringify(uuidv4()))

    if (typeof window !== 'undefined' && window.ym) {
      window.ym(92116660, 'reachGoal', 'lead-test')
    }

    margetingLead({
      program: null,
      googleClientId: cookies.gclUid || null
    })
  }
}
